<template>
    <inertia-head title="Sök" />

    <main role="main" class="main search-results">
        <div class="container pb-5">
            <h3 class="search-query">{{ $t('you_searched_for') }} <span class="averta-black">"{{term}}"</span></h3>

            <div>
                {{ hits }}
                <span v-if="hits === 1">träff</span>
                <span v-else>träffar</span>
            </div>

            <company-type-filter
                @changed="update"
                v-model:showLocals="locals"
                v-model:showWebshops="webshops">
            </company-type-filter>

            <select class="mt-2 badge badge-secondary ms-2" v-model="selectedCity" @change="update">
                <option :value="null">Hela landet</option>
                <option v-for="city in cities" :value="city.slug" :selected="selectedCity === city.slug">{{ city.name }}</option>
            </select>

            <h3 class="search-query" v-if="results.campaigns.length">Erbjudanden</h3>

            <div class="list-result-container" style="min-height:0px;">
                <div class="list-result container" style="min-height:0px;" v-if="results.campaigns.length">
                    <div class="row gx-3 mt-2">
                        <div class="col-6 col-md-3 mb-4" v-for="campaign in results.campaigns" :key="campaign.id">
                            <campaign-item :campaign="campaign" />
                        </div>
                    </div>
                </div>
            </div>

            <h3 class="search-query mt-5 pt-0" v-if="results.companies.length">Företag</h3>

            <div class="list-result-container">
                <div class="list-result container" v-if="results.companies.length">

                    <div class="row mt-2">
                        <div class="col-6 col-md-3 px-2 mb-4" v-for="company in results.companies">
                            <inertia-link :href="`/${company.slug}`">
                                <div class="company-item relative" style="height: 200px;text-align: center;background-color: #fff;osition: relative;">
                                    <img v-if="company.logo" :src="company.logo" class="logo" style="max-height: 80px;max-width: 80%;position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;border: none;vertical-align: middle;">
                                    <div style="display: flex;justify-content: center;align-items:center;height: 100%;" v-if="!company.logo">
                                        <span>{{ company.name }}</span>
                                    </div>
                                </div>
                            </inertia-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import { router } from '@inertiajs/vue3'
    import CompanyTypeFilter from '@/components/CompanyTypeFilter.vue';

    export default {
        props: ['term', 'companies', 'campaigns'],
        components: { CompanyTypeFilter },

        data() {
            return {
                hits: 0,
                locals: true,
                webshops: true,
                selectedCity: null,
                results: { companies: [], campaigns: [] },
            };
        },

        mounted () {
            this.results.companies = this.companies;
            this.results.campaigns = this.campaigns;
            this.hits = (this.results.campaigns.length + this.results.companies.length);

            let params = (new URL(document.location)).searchParams;

            if (params.has('city')) {
                this.selectedCity = params.get('city');
            }

            if (params.has('webshops')) {
                this.webshops = JSON.parse(params.get('webshops'));
            }

            if (params.has('locals')) {
                this.locals = JSON.parse(params.get('locals'));
            }

            // this.$gtag.query('event', 'search', {
            //     search_term: this.term
            // });
        },

        metaInfo() {
            return {
                title: 'Sök - Familjekortet',
            };
        },

        methods: {
            urlParams () {
                let params = {
                    term: this.term,
                    locals: this.locals,
                    webshops: this.webshops
                };

                if (this.selectedCity) {
                    params.city = this.selectedCity;
                }

                return Object.keys(params).map(key => key + '=' + params[key]).join('&');
            },

            update (e) {
                router.visit(`/sok?${this.urlParams()}`);
            }
        },

        computed: {
            cities() {
                return this.$page.props.cities;
            }
        }
    }
</script>
